module.exports = __webpack_public_path__ + "img/slide-bar-off_04.026a1886.png";